<template>
  <section
    aria-label="Explore Alabama"
    class="articles-section container"
    v-if="articles.length > 0"
  >
    <div class="experience-articles">
      <h2 class="experience-articles-title">{{ articleTitle }}</h2>
      <p class="experience-articles-content" v-html="articleContent"></p>
    </div>
    <div class="grid-articles" v-if="articles.length >= 6">
      <article
        class="col"
        v-for="(article, index) in isMobile ? articles : articles.slice(0, currentArticleCount)"
        :key="index"
      >
        <img :src="article.featured_image" :alt="article.featured_image_alt" />
        <div class="article-preview">
          <div>
            <p>
              <span class="article-category">{{
                article.categories[0].name
              }}</span>
              <br />
              <span class="article-title">{{
                article.title.length > 40
                  ? `${article.title.slice(0, 40)}...`
                  : article.title
              }}</span>
            </p>
            <p class="article-summary">{{ article.summary }}</p>
          </div>
          <router-link :to="`/article/${article.slug}`" class="blue-button">
            Read Full Article
          </router-link>
        </div>
      </article>
    </div>
    <div class="grid-articles-sm" v-else>
      <article
        class="col-sm"
        v-for="(article, index) in isMobile ? articles : articles.slice(0, 6)"
        :key="index"
      >
        <img :src="article.featured_image" :alt="article.featured_image_alt" />
        <div class="article-preview">
          <div>
            <p>
              <span class="article-category">{{
                article.categories[0].name
              }}</span>
              <br />
              <span class="article-title">{{
                article.title.length > 40
                  ? `${article.title.slice(0, 45)}...`
                  : article.title
              }}</span>
            </p>
            <p class="article-summary">{{ article.summary }}</p>
          </div>
          <router-link :to="`/article/${article.slug}`" class="blue-button">
            Read Full Article
          </router-link>
        </div>
      </article>
    </div>
    <button v-if="!isMobile && articles.length > currentArticleCount" class="load-button" @click="loadMoreArticles(8)">
      {{ isLoadingArticles ? 'Loading...' : 'Load More Articles' }}
    </button>
  </section>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import Butter from 'buttercms';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

function removeImages(str) {
  return str.replace(/<img[^>"']*((("[^"]*")|('[^']*'))[^"'>]*)*>/g, '');
}

@Component({
  components: {},
  props: {
    categorySlug: {
      type: String,
      default: '',
    },
    articleTitle: {
      type: String,
      default: '',
    },
    articleContent: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      articles: [],
      articlesFromButter: [],
      categories: [{}],
      articlePosts: [],
      currentArticleCount: 6,
      isLoadingArticles: false,
      isMobile: false,
    };
  },
  methods: {
    getArticles() {
      butter.post
        .list({
          page: 1,
          page_size: 1000,
          order: '-published',
          exclude_body: false,
          category_slug: this.categorySlug,
        })
        .then((res) => {
          this.articlesFromButter = res.data.data;
          this.articlesFromButter.forEach((a) => {
            const article = {};
            article.title = a.title;
            article.body = removeImages(a.body);
            article.featured_image = a.featured_image;
            article.summary = a.summary;
            article.slug = a.slug;
            article.categories = a.categories;
            article.tags = a.tags;
            this.articlePosts.push(article);
            this.articles.push(article);
          });
          this.articles.sort((a, b) => {
            if (
              a.tags.filter((x) => x.name === 'featured').length <
              b.tags.filter((x) => x.name === 'featured').length
            ) {
              return 1;
            }
            if (
              a.tags.filter((x) => x.name === 'featured').length >
              b.tags.filter((x) => x.name === 'featured').length
            ) {
              return -1;
            }
            return 0;
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },
    async loadMoreArticles(count) {
      try {
        this.isLoadingArticles = true;
        await new Promise(resolve => setTimeout(resolve, 1000));
        this.currentArticleCount += count;
      } finally {
        this.isLoadingArticles = false;
      }
    },
    handleResize() {
      this.isMobile = window.innerWidth < 1201;
    },
  },
  async created() {
    await this.getArticles();
  },
  mounted() {
    this.isMobile = window.innerWidth < 1201;
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
})
class ExperienceArticles extends Vue {}

export default ExperienceArticles;
</script>

<style lang="scss" scoped>
.articles-section {
  margin-top: 5rem;
  max-width: 1450px;
}
.experience-articles {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4rem;
  padding-bottom: 1rem;
  @media only screen and (min-width: 1200px) {
    padding-bottom: 0rem;
    margin-bottom: 0rem;
  }
}
.experience-articles-title {
  font-size: 40px;
  line-height: 48px;
  font-family: 'klinicslabbold';
  color: #000000;
}
.experience-articles-content {
  max-width: 720.39px;
  height: 39px;
  font-size: 1rem;
  font-weight: 325;
  line-height: 19.2px;
  font-family: 'IdealSans-Book';
  color: #173945;
  text-align: center;
  margin-bottom: 2rem;
}

a {
  color: #173945;

  &:hover,
  &:focus-visible {
    text-decoration: none;
  }

  &:visited {
    color: #173945;
  }
}

a.button {
  color: #ffffff;
}

img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.grid-articles {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 16rem 30rem;
  grid-gap: 2rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  @media only screen and (max-width: 1200px) {
    flex: 1;
    display: flex;
    overflow: auto;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }
}
.grid-articles-sm {
  display: grid;
  grid-gap: 2rem;
  margin-top: 1rem;
  padding-bottom: 1rem;
  grid-auto-flow: column; /* column flow */
  justify-content: center;
  @media only screen and (max-width: 1200px) {
    flex: 1;
    display: flex;
    overflow: auto;
    margin-bottom: 4rem;
    padding-bottom: 1rem;
    justify-content: flex-start;
  }
}
.col:nth-child(1),
.col:nth-child(2) {
  display: grid;
  grid-row: 1;
  grid-column: span 6;
  grid-gap: 2rem;
  grid-template-columns: repeat(2, 1fr);
  @media only screen and (max-width: 1200px) {
    grid-template-columns: auto;
    grid-template-rows: 13rem auto;
    display: grid;
    grid-gap: 1rem;
  }
}
.col:nth-child(n+3) {
  display: grid;
  grid-row: span 1;
  grid-column: span 3;
  min-height: 10rem;
  grid-template-rows: 13rem auto;
  grid-gap: 1rem;
}
.col {
  border: none;
  border-radius: 15px;
  border-collapse: collapse;
  overflow: hidden;
  perspective: 1px;
  box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1);
  padding: 0px;
  flex: none;
  @media only screen and (max-width: 1200px) {
    width: 15rem;
  }
}
.col-sm {
  border: none;
  border-radius: 15px;
  border-collapse: collapse;
  overflow: hidden;
  perspective: 1px;
  box-shadow: 0px 6px 6px -1px rgba(10, 22, 70, 0.1);
  padding: 0px;
  flex: none;
  min-height: 10rem;
  display: grid;
  grid-template-rows: 13rem auto;
  grid-gap: 1rem;
  width: 20rem;
  @media only screen and (max-width: 1200px) {
    width: 15rem;
  }
}
.col-sm:nth-child(4n + 1) {
  grid-column: 1;
}
.col-sm:nth-child(4n + 2) {
  grid-column: 2;
}
.col-sm:nth-child(4n + 3) {
  grid-column: 3;
}
.col-sm:nth-child(4n + 4) {
  grid-column: 4;
}
.col-sm:nth-child(4n + 5) {
  grid-column-start: 1;
  grid-column-end: 5;
  margin: 0 auto;
}
.load-button {
  display: none;
  @media only screen and (min-width: 1200px) {
    display: inline-block;
    background-color: white;
    color: #173945;
    font-family: 'IdealSans-Book';
    font-size: 12px;
    width: 145px;
    height: 28px;
    border-radius: 1rem;
    border: 1px solid #173945;

    &:hover,
    &:focus-visible {
      background-color: #173945;
      color: white;
    }
  }
}
.article-preview {
  text-align: left;
  padding: 0 1rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.article-category {
  font-size: 1rem;
  font-family: 'klinicslabbold';
  text-transform: uppercase;
  color: #4e97b2;
}
.article-title {
  font-size: 1.5rem;
  font-family: 'klinicslabbold';
  line-height: 1.5rem;
}
.article-summary {
  font-size: 1rem;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  word-wrap: break-word;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}
.blue-button,
.blue-button:visited {
  background-color: #173945;
  border-radius: 2px;
  border: solid 1px #4e97b2;
  color: #fff;
  font-size: 14px;
  padding: 10px 20px 10px 20px;
  text-decoration: none;
  text-align: center;
  max-width: fit-content;
}
.blue-button:hover,
.blue-button:focus,
.blue-button:focus-visible {
  border: solid 1px #4e97b2;
  background-color: #316273;
}
</style>
